
import axios from 'axios';
import config from '../../config';
import { Error, API } from './base';


class Engine {
    constructor(obj){
        Object.assign(this, obj)
    }
}


class EnginesAPI extends API {

    url() {
        return config.get("re.url") + "enginesprovidersdb";
    }


    getAll() {
        return new Promise((resolve, reject) => {
            axios.get(
                this.url(),
                this._getHeaders(),

            ).then(response => {
                if (response.status === 200) {
                    const engines = [];
                    response.data.enginesprovidersdb.forEach(a => {
                      engines.push(new Engine(a));
                    });
                    resolve(engines);
                } else {
                    const err = new Error(response.status, "Failed to fetch engines", JSON.stringify(response.data));
                    reject(err);
                }

            }).catch(err => {
                reject(err);
            });
        })
    }

    get(id) {
        return new Promise((resolve, reject) => {
            axios.get(
              this.url() + "/"+ id,
              this._getHeaders(),

            ).then(response => {
                if (response.status === 200) {
                    resolve(new Engine(response.data.enginesprovidersdb));
                } else {
                    const err = new Error(response.status, "Failed to fetch engine", JSON.stringify(response.data));
                    reject(err);
                }

            }).catch(err => {
                reject(err);
            });
        })
    }

    update(engine) {
        return new Promise((resolve, reject) => {
            axios.patch(
                this.url() + engine.id,
                engine,
                this._getHeaders(),
            ).then(response => {
                if (response.status >= 200 && response.status < 400) {
                    resolve();
                } else {
                    const err = new Error(response.status, "Failed to update engine", JSON.stringify(response.data));
                    reject(err);
                }
            }).catch(err => {
                reject(err);
            });
        });
    }

    delete(id) {
        return new Promise((resolve, reject) => {
            axios.delete(
                this.url() +"/"+ id,
                this._getHeaders(),
            ).then(response => {
                if (response.status >= 200 && response.status < 400) {
                    resolve();
                } else {
                    const err = new Error(response.status, "Failed to delete engine", JSON.stringify(response.data));
                    reject(err);
                }
            }).catch(err => {
                reject(err);
            });
        });
    }

    create(engine) {
        return new Promise((resolve, reject) => {
            axios.post(
                this.url(),
                engine,
                this._getHeaders(),
            ).then(response => {
                if (response.status === 201) {
                    resolve(new Engine(response.data.engine));
                } else {
                    const err = new Error(response.status, "Failed to create engine", JSON.stringify(response.data));
                    reject(err);
                }
            }).catch(err => {
                reject(err);
            });
        });
    }
}

export {
    EnginesAPI, Engine
};